import { CSSProperties } from 'react'

export const s = {
  spaceBetweenRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 18,
  } as CSSProperties,
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  } as CSSProperties,
  paperClip: {
    fontSize: 26,
  },
  divider: {
    margin: 0,
  },
}
